import {ParamsModel} from 'src/app/modules/common/Model'
import {COMMON_TYPES, BENEFIT_LIST_TYPES} from './constants'

export const getBenfitListDetails = (params: ParamsModel = {page: 1, limit: 10}) => ({
  type: BENEFIT_LIST_TYPES.GET_BENEFIT_LIST + COMMON_TYPES.REQUEST,
  payload: params,
})
